// extracted by mini-css-extract-plugin
export var productImage = "_py-1";
export var viewLink = "_py-2";
export var wishlistItem = "_py-0";